import type { ISerialize } from '@/objects/ISerialize';

export class ReportBibAssignPreviewRequest implements ISerialize {
    public CategoryIDs: number[];

    public FederationID: number;

    public GroupIDs: number[];

    public KeepAssigned: boolean;

    public OverwriteStarttimes: boolean;

    public RaceIDs: number[];

    public Shuffle: boolean;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        CategoryIDs?: number[];
        FederationID?: number;
        GroupIDs?: number[];
        KeepAssigned?: boolean;
        OverwriteStarttimes?: boolean;
        RaceIDs?: number[];
        Shuffle?: boolean;
    }) {
        this.CategoryIDs = values.CategoryIDs ?? [];

        this.FederationID = values.FederationID ?? 0;

        this.GroupIDs = values.GroupIDs ?? [];

        this.KeepAssigned = values.KeepAssigned ?? false;

        this.OverwriteStarttimes = values.OverwriteStarttimes ?? false;

        this.RaceIDs = values.RaceIDs ?? [];

        this.Shuffle = values.Shuffle ?? false;
    }

    public serialize(): string {
        return (
            '{' +
            `"CategoryIDs": [ ${this.CategoryIDs.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"FederationID": ${JSON.stringify(this.FederationID)}` +
            ',' +
            `"GroupIDs": [ ${this.GroupIDs.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"KeepAssigned": ${JSON.stringify(this.KeepAssigned)}` +
            ',' +
            `"OverwriteStarttimes": ${JSON.stringify(this.OverwriteStarttimes)}` +
            ',' +
            `"RaceIDs": [ ${this.RaceIDs.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"Shuffle": ${JSON.stringify(this.Shuffle)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ReportBibAssignPreviewRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        CategoryIDs?: number[];
        FederationID?: number;
        GroupIDs?: number[];
        KeepAssigned?: boolean;
        OverwriteStarttimes?: boolean;
        RaceIDs?: number[];
        Shuffle?: boolean;
    }): ReportBibAssignPreviewRequest {
        return new ReportBibAssignPreviewRequest(values);
    }

    public static _FromServerJson(json: any): ReportBibAssignPreviewRequest {
        return new ReportBibAssignPreviewRequest({
            CategoryIDs: json.CategoryIDs,
            FederationID: json.FederationID,
            GroupIDs: json.GroupIDs,
            KeepAssigned: json.KeepAssigned,
            OverwriteStarttimes: json.OverwriteStarttimes,
            RaceIDs: json.RaceIDs,
            Shuffle: json.Shuffle,
        });
    }

    /**
     * Creates an instance of ReportBibAssignPreviewRequest from another instance of ReportBibAssignPreviewRequest.
     * @param other The ReportBibAssignPreviewRequest you want to clone
     * @returns A cloned ReportBibAssignPreviewRequest
     */
    public static FromOther(other: ReportBibAssignPreviewRequest): ReportBibAssignPreviewRequest {
        return ReportBibAssignPreviewRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ReportBibAssignPreviewRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'ReportBibAssignPreviewRequest';
}
